"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeatureAttributes = getFeatureAttributes;
const evaluateRule_1 = require("./evaluateRule");
const featureFlagsHolderObject_1 = require("./featureFlagsHolderObject");
const getFeatureFlagConfig_1 = require("./getFeatureFlagConfig");
function getFeatureAttributes(component, flag, context) {
    var _a, _b, _c, _d, _e, _f, _g;
    const variants = (_b = (_a = (0, getFeatureFlagConfig_1.getFeatureFlagConfig)()) === null || _a === void 0 ? void 0 : _a[component]) === null || _b === void 0 ? void 0 : _b[flag];
    if (variants) {
        for (const variant of variants) {
            try {
                if (!variant.rule || (0, evaluateRule_1.evaluateRule)(variant.rule, context !== null && context !== void 0 ? context : featureFlagsHolderObject_1.featureFlagsHolderObject.context)) {
                    if (variant.enabled) {
                        const schemaAttributes = (_f = (_e = (_d = (_c = featureFlagsHolderObject_1.featureFlagsHolderObject.schema) === null || _c === void 0 ? void 0 : _c[component]) === null || _d === void 0 ? void 0 : _d.flags) === null || _e === void 0 ? void 0 : _e[flag]) === null || _f === void 0 ? void 0 : _f.attributes;
                        const attributes = {};
                        if (schemaAttributes) {
                            for (const [key, attribute] of Object.entries(schemaAttributes)) {
                                if ((attribute === null || attribute === void 0 ? void 0 : attribute.defaultValue) != null) {
                                    if (variant.attributes && typeof variant.attributes[key] === typeof attribute.defaultValue) {
                                        attributes[key] = variant.attributes[key];
                                    }
                                    else {
                                        attributes[key] = attribute.defaultValue;
                                    }
                                }
                            }
                        }
                        return attributes;
                    }
                    else {
                        return undefined;
                    }
                }
            }
            catch (error) {
                (_g = featureFlagsHolderObject_1.featureFlagsHolderObject.logRuleEvaluationError) === null || _g === void 0 ? void 0 : _g.call(featureFlagsHolderObject_1.featureFlagsHolderObject, {
                    error,
                    variant: variant,
                    context: context !== null && context !== void 0 ? context : featureFlagsHolderObject_1.featureFlagsHolderObject.context,
                });
            }
        }
    }
    return undefined;
}
